module.exports = __webpack_public_path__ + "assets/b37ba6d16eb7a2a609490c2caa63dc0e.mp3";